import PropTypes from "prop-types";

/**
 * Shared PropTypes for metric cards
 */
export const metricCardPropTypes = {
  icon: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  current: PropTypes.number,
  currentFormatted: PropTypes.string,
  target: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  targetFormatted: PropTypes.string,
  deltaFormatted: PropTypes.string,
  ragStatus: PropTypes.oneOf(["green", "amber", "red", "grey"]).isRequired,
  loading: PropTypes.bool,
  subtitleText: PropTypes.string,
  targetChanged: PropTypes.bool,
};

export const metricCardDefaultProps = {
  loading: false,
};

/**
 * Calculate display value from current and currentFormatted props
 * @param {number|null|undefined} current - Current numeric value
 * @param {string|undefined} currentFormatted - Pre-formatted string value
 * @returns {string|number} - Display value or "N/A"
 */
export const getDisplayValue = (current, currentFormatted) => {
  if (currentFormatted !== undefined) {
    return currentFormatted;
  }
  if (current !== null && current !== undefined) {
    return current;
  }
  return "N/A";
};

/**
 * Format target display value
 * @param {number|object} target - Target value or range object
 * @param {string|undefined} targetFormatted - Pre-formatted target string
 * @returns {string} - Formatted target display
 */
export const formatTargetDisplay = (target, targetFormatted) => {
  if (targetFormatted !== undefined) {
    return targetFormatted;
  }
  if (target === null || target === undefined) {
    return "N/A";
  }
  if (typeof target === "object" && target.min !== undefined) {
    return `${target.min}-${target.max}`;
  }
  return target;
};

/**
 * Format display value for number formatting
 * @param {string|number} displayValue - Value to format
 * @returns {string|number} - Formatted value
 */
export const formatDisplayValue = (displayValue) => {
  if (typeof displayValue === "number") {
    return displayValue.toLocaleString();
  }
  return displayValue;
};

/**
 * Build subtitle text showing value, target, and delta
 * @param {string|number} displayValue - Current display value
 * @param {string} targetDisplay - Formatted target display
 * @param {string} deltaFormatted - Formatted delta string
 * @returns {string} - Subtitle text
 */
export const buildSubtitleText = (
  displayValue,
  targetDisplay,
  deltaFormatted
) => {
  return `${displayValue} / ${targetDisplay} / ${deltaFormatted}`;
};
